import { Button, Card, Empty, Flex, Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import dayjs from 'dayjs'
import { useState } from 'react'

import {
  GetListPregnancyMonitoringInvestigationsResponse,
  PregnancyMonitoringPlanInvestigationItemDto,
  PregnancyMonitoringPlanInvestigationStatus
} from 'src/api/requests'
import {
  PregnancyInvestigationsStatusTag,
  PregnancyPeriodStatusTag
} from 'src/features/persons/components'
import { dayMonthYearBackSlash } from 'src/libs'
import { useLocales } from 'src/locales'

import { PregnancyInvestigationsModal } from './PregnancyInvestigationsModal'

type Props = {
  id?: string
  investigations?: GetListPregnancyMonitoringInvestigationsResponse
}

export const PregnancyInvestigationsCard = ({ id, investigations }: Props) => {
  const { t } = useLocales()

  const [modalState, setModalState] = useState<{
    id?: string
    data?: PregnancyMonitoringPlanInvestigationItemDto | null
  }>({ data: null, id: String(id) })

  const onCancel = () => {
    setModalState({ data: null, id: '' })
  }

  const columns: ColumnsType<PregnancyMonitoringPlanInvestigationItemDto> = [
    {
      key: 'created date',
      title: t('pregnancy.investigation_limit_date'),
      render: ({ periodDate }: { periodDate: string }) =>
        dayjs.utc(periodDate).tz().format(dayMonthYearBackSlash)
    },
    {
      key: 'pregnancyPeriod',
      title: t('pregnancy.monitoring_period'),
      render: (_, { pregnancyPeriod }) => (
        <PregnancyPeriodStatusTag status={pregnancyPeriod} />
      )
    },
    {
      key: 'status',
      title: t('form.status'),
      render: (_, { status }) => (
        <PregnancyInvestigationsStatusTag status={status} />
      )
    },
    {
      key: 'actions',
      title: t('common.action'),
      render: (record) => {
        const isToDoStatus =
          record?.status === PregnancyMonitoringPlanInvestigationStatus.TO_DO ||
          record?.status ===
            PregnancyMonitoringPlanInvestigationStatus.NEED_TO_INVESTIGATE

        return isToDoStatus ? (
          <Button
            type="primary"
            onClick={() => setModalState({ data: record })}
          >
            {t('pregnancy_monitoring.add')}
          </Button>
        ) : null
      }
    }
  ]

  return (
    <>
      <Card title={t('persons.person_investigations')}>
        {investigations?.data?.length ? (
          <Flex vertical gap={24}>
            <Table
              rowKey="id"
              bordered
              columns={columns}
              scroll={{ x: 'max-content' }}
              dataSource={investigations?.data}
              pagination={false}
            />
          </Flex>
        ) : (
          <Empty />
        )}
      </Card>

      {modalState.data && (
        <PregnancyInvestigationsModal
          onCancel={onCancel}
          data={{
            id: String(id),
            data: modalState.data
          }}
        />
      )}
    </>
  )
}
